import { useState } from 'react'
import type { InquiryAssignLocal } from '../components/AssignTab/types'

export function usePropertiesAssignDialogs() {
  const [reasonDialog, setReasonDialog] = useState<{ open: boolean; statusId: number; statusName: string }>({
    open: false,
    statusId: 0,
    statusName: '',
  })

  const [assignDialog, setAssignDialog] = useState<{ open: boolean; assign: InquiryAssignLocal | null }>({
    open: false,
    assign: null,
  })

  const [assignDeleteTargetId, setAssignDeleteTargetId] = useState<number | null>(null)

  const openReasonDialog = (statusId: number, statusName: string) => {
    setReasonDialog({ open: true, statusId, statusName })
  }

  const closeReasonDialog = () => {
    setReasonDialog({ open: false, statusId: 0, statusName: '' })
  }

  const openAddAssignDialog = () => {
    setAssignDialog({ open: true, assign: null })
  }

  const openEditAssignDialog = (assign: InquiryAssignLocal) => {
    setAssignDialog({ open: true, assign })
  }

  const closeAssignDialog = () => {
    setAssignDialog({ open: false, assign: null })
  }

  const openDeleteAssignDialog = (id: number) => {
    setAssignDeleteTargetId(id)
  }

  const closeDeleteAssignDialog = () => {
    setAssignDeleteTargetId(null)
  }

  return {
    reasonDialog,
    assignDialog,
    assignDeleteTargetId,
    openReasonDialog,
    closeReasonDialog,
    openAddAssignDialog,
    openEditAssignDialog,
    closeAssignDialog,
    openDeleteAssignDialog,
    closeDeleteAssignDialog,
  }
}
